// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__MO77e","card__inner":"styles_card__inner__wrD6O","blob":"styles_blob__lQdeo","fake_blob":"styles_fake_blob__tKiku"};